import { Button, Card, Col, Form, Row, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import moment from "moment";

function TotalLeaveDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [meta, setMeta] = useState<any>({});
  const [selectdata, setselectData] = useState([]);

  // Function to search leave with filters
  const SearchLeave = async (values: any) => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query"),
        status: values.status,
        month: values.month, // Pass the selected month
        employeeId: values?.employeeId, // Pass the selected employee
        page: page,
        take: pageSize,
      };
      const url = API.SEARCH_LEAVE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to fetch employee data for filtering
  const filterEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, []);
      setselectData(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to fetch leave data with pagination
  const fetchLeave = async (currentPage: number, pageSize: any) => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query"),
        page: currentPage,
        take: pageSize,
      };
      const url = API.LIST_LEAVE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    filterEmployee(); // Fetch employee data for the dropdown
    fetchLeave(page, pageSize); // Fetch leave data initially
  }, [page, pageSize]);

  const columns = [
    {
      dataIndex: "type",
      title: "Type",
    },
    {
      dataIndex: "approver",
      title: "Approver",
    },
    {
      dataIndex: "from",
      title: "From",
      render: (from: any) => (from ? moment(from).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "to",
      title: "To",
      render: (to: any) => (to ? moment(to).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (status: any) => {
        let color = "";
        switch (status?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black";
        }
        return <span style={{ color }}>{status}</span>;
      },
    },
    {
      dataIndex: "employeeId",
      title: "Employee",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "description",
      title: "Description",
    },
    {
      dataIndex: "createdBy",
      title: "Created By",
    },
  ];

  return (
    <div>
      <Card>
        <Form form={form} onFinish={SearchLeave} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                label="Employee Name"
                name="employeeId"
                style={{ marginBottom: 10 }}
              >
                <Select
                  placeholder="Select an employee"
                  size="large"
                  allowClear
                >
                  {selectdata?.map((user: any) => (
                    <Select.Option key={user?.id} value={user?.id}>
                      {user?.fullName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* Month Filter */}
            <Col sm={6}>
              <Form.Item
                label="Month"
                name="month"
                style={{ marginBottom: 10 }}
              >
                <Select placeholder="Select a month" size="large" allowClear>
                  {Array.from({ length: 12 }, (_, i) => (
                    <Select.Option key={i + 1} value={i + 1}>
                      {moment().month(i).format("MMMM")}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                label="Status"
                name="status"
                style={{ marginBottom: 10 }}
              >
                <Select placeholder="Select Status" size="large" allowClear>
                  <Select.Option value="approved">Approved</Select.Option>
                  <Select.Option value="rejected">Rejected</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Card>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total || 0,
            showSizeChanger: true,
            onChange: (currentPage: any, currentPageSize: any) => {
              setPage(currentPage);
              setPageSize(currentPageSize);
              fetchLeave(currentPage, currentPageSize);
            },
          }}
          loading={isLoading}
        />
      </Card>
    </div>
  );
}

export default TotalLeaveDetails;
